import { Box, Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const AboutUs = () => {
    const { about_us, address, email } = useSelector(state => state.shop)
    return (
        < Container >
            <Box
                sx={{
                    width: '100%', overflowX: 'auto', mb: 4
                }}
                dangerouslySetInnerHTML={{ __html: about_us.replace(/Localhost/g, `${window.location.hostname.toUpperCase()}`) }}
            />
            <Typography ><b>Address:</b> {address}</Typography>
            <Typography ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
            <Typography ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
        </Container >
    )
};

export default AboutUs;
